import axios from './axiosInstance';
import { Globals } from '../global/Globals';

export const getRecordsFromResetLink = async (link) => {
  const apiResponse = await axios.get(Globals.ENDPOINT.RESET_ACCOUNT_FETCH + link);
  return apiResponse;
}

export const resetAccount = async (email, password, link) => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };
  const body = {
    "email": email,
    "password": password
  };
  const apiResponse = await axios.put(Globals.ENDPOINT.RESET_ACCOUNT + link, JSON.stringify(body), config);
  return apiResponse;
}